<script setup lang="ts" name="RegistrationSelectionLayout">
const { title } = defineProps<{
  title?: string;
  variant: 'minimal' | 'default';
}>();
</script>

<template>
  <div class="flex flex-col items-center">
    <p class="text-body-1 text-charcoal-6">{{ title }}</p>
    <div
      class="my-4 flex flex-wrap gap-2"
      :class="{
        'mb-0 justify-start': variant === 'minimal',
        'justify-center': variant === 'default',
      }"
    >
      <slot />
    </div>
  </div>
</template>
